export const DOMAIN = 'langhout-api.wimsp.nl';
export const JWT_KEY_LOCALSTORAGE = 'jwt';
export const JWT_OTP_KEY_LOCALSTORAGE = 'jwt_otp';
